export default class ThingNameController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onChanges({ name }) {
        this.originalName = name.currentValue;
    }

    save() {
        if (this.name !== this.originalName) {
            this.onUpdate(
                this.eventEmitter({
                    patch: {
                        name: this.name
                    }
                })
            );
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-name/thing-name.controller.js